// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"3b53517f","119":"3b53517f","517":"c77a3b34"}[chunkId] + ".chunk.css";
};